// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    backgroundColor: theme.white,
    border: `1px solid ${theme.colors.gray2[0]}`,
    borderRadius: theme.other.spacing._32,
    paddingTop: theme.other.spacing._8,
    paddingRight: theme.other.spacing._16,
    paddingBottom: theme.other.spacing._8,
    paddingLeft: theme.other.spacing._16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.other.spacing._4,
  },

  label: {
    color: theme.colors.gray2[3],
  },

  time: {
    color: theme.colors.red[5],
  },
}));
